import { createSlice } from '@reduxjs/toolkit';
import { StatementRelativePeriods, StatementType } from 'shared';

const initState: {
  currentCurrency: string;
  statementPeriod: StatementRelativePeriods;
  statementType: StatementType;
  activityPeriodStart: string | null;
  activityPeriodEnd: string | null;
} = {
  currentCurrency: ``,
  statementPeriod: StatementRelativePeriods.ALL_TIME_INC_FUTURE,
  statementType: StatementType.OUTSTANDING,
  activityPeriodStart: null,
  activityPeriodEnd: null,
};

const contactPagePrefsSlice = createSlice({
  name: `contactPagePrefs`,
  initialState: initState,
  reducers: {
    setCurrentCurrency(state, action) {
      state.currentCurrency = action.payload;
    },
    setStatementPeriod(state, action) {
      state.statementPeriod = action.payload;
    },
    setStatementType(state, action) {
      state.statementType = action.payload;
    },
    setActivityPeriodStart(state, action) {
      state.activityPeriodStart = action.payload;
    },
    setActivityPeriodEnd(state, action) {
      state.activityPeriodEnd = action.payload;
    },
  },
});

export const { setCurrentCurrency,  setStatementPeriod, setStatementType, setActivityPeriodStart, setActivityPeriodEnd } = contactPagePrefsSlice.actions;

export const contactPagePrefsReducer = contactPagePrefsSlice.reducer;
